import * as AdministrationAccountsActions from '../../administration-accounts.actions';
import {TAB_SHOW} from '../../../../../common/tabs/tabs.constants';

/**
 * @const {object}
 * @memberOf module:Administration
 */
export const administrationAccountsRoomDocuments = {
    /* @ngInject */
    controller: function ($ngRedux, $state, $mdDialog, $rootScope, $uiRouterGlobals) {
        /**
         * @function $onInit
         */
        this.$onInit = () => {
            this.unsubscribe = $ngRedux.connect(( state ) => ({
                document: state.administration.administrationAccountsRoomDocument
            }), {
                ...AdministrationAccountsActions
            })(this);
        }

        /**
         * @method addDocument
         */
        this.addDocument = () => {
            if ($ngRedux.getState().administration.administrationAccountsRoomDocument.docNum) {
                $ngRedux.dispatch({
                    type: 'DOCUMENT_RESET',
                    id: 'administrationAccountsRoomDocument'
                });
            }
            $ngRedux.dispatch({
                type: 'TAB_SHOW',
                id: 'app.administration.accounts.rooms',
                state: ['app.administration.accounts.rooms.documentDetails'],
                stateParams: $uiRouterGlobals.params
            });
        };

        this.onSelect = ({item}) => {
            this.getDocumentDetails(item.id).then(() => {
                $ngRedux.dispatch({
                    type: 'TAB_SHOW',
                    id: 'app.administration.accounts.rooms',
                    state: ['app.administration.accounts.rooms.documentDetails'],
                    stateParams: { id: item.id }
                });
            });
        };

        this.onRemove = ({ item }) => {
            const confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .textContent('Chosen document will be inactivated.')
                .ariaLabel('Inactivate document')
                .ok('Yes')
                .cancel('No');
            this.dialog = $mdDialog.show(confirm).then(() => {
                this.invalidateDocument(item.id);
            }, angular.noop);
        };

        /**
         * @function $onDestroy
         */
        this.$onDestroy = () => {
            this.unsubscribe();
            this.dialog && $mdDialog.hide(this.dialog);
        };
    },
    template: `
        <administration-accounts-documents-grid
            identifier="administrationAccountsRoomDocumentsGrid"
            on-select="$ctrl.onSelect($event)" 
            on-remove="$ctrl.onRemove($event)"
            on-reset="$ctrl.onReset($event)">
        </administration-accounts-documents-grid>
        
        <tabs-navigation identifier="app.administration.accounts.rooms"
                         state="app.administration.accounts.rooms.documents"
                         on-exec="$ctrl.addDocument()">
        </tabs-navigation>
    `
};
